import { render } from "./mostrarPresencaOuFalta.vue?vue&type=template&id=1fe13264&scoped=true"
import script from "./mostrarPresencaOuFalta.vue?vue&type=script&lang=js"
export * from "./mostrarPresencaOuFalta.vue?vue&type=script&lang=js"

import "./mostrarPresencaOuFalta.vue?vue&type=style&index=0&id=1fe13264&lang=scss&scoped=true"
import "./mostrarPresencaOuFalta.vue?vue&type=style&index=1&id=1fe13264&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe13264"]])

export default __exports__